// undefined until resolved, because the resolved value may itself be null and
// has to be cached rather than recomputed on every call.
let apiHost;

/**
 * Returns `{ apiHost }`, where `apiHost` is the origin the bundle was served
 * from, so API calls target the bundle's origin rather than the host page's.
 * `apiHost` is null where the bundle has no usable origin, and callers then
 * resolve their path against the document.
 *
 * @returns {{ apiHost: string|null }}
 */
export function getApiHost() {
  if (apiHost === undefined) {
    apiHost = bundleOrigin();
  }

  return { apiHost };
}

// A file: or data: URL has an opaque origin, which `URL` serializes as the
// string "null" — truthy, and rejected as a base by the URL constructor. Under
// a test runner the bundle is a file: URL, so returning it hands every client a
// base that throws `ERR_INVALID_URL` on the first request.
function bundleOrigin() {
  const { origin } = new URL(import.meta.url);

  return origin === "null" ? null : origin;
}
